import React, { useEffect, useRef, useState } from 'react';
import { formatHistoryTime } from '../utils/time';
import './SystemHealthIndicator.css';

interface SystemHealth {
  code: string;
  label: string;
  tone: string;
  checkedAt: string;
  lastScanAt: string | null;
  issues: { code: string; severity: string; message: string }[];
  info: string[];
}

export function SystemHealthIndicator({ health, error, receivedAt }: { health?: SystemHealth; error: string | null; receivedAt: number | null }) {
  const [now, setNow] = useState(Date.now);
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const stale = receivedAt !== null && now - receivedAt > 12000;
  const unknown = !!error || stale || !health;
  const tone = error ? 'danger' : stale ? 'warning' : health?.tone || 'neutral';
  const label = error ? 'Нет связи с API' : stale ? 'Статус устарел' : health?.label || (receivedAt ? 'Статус недоступен' : 'Проверяем систему');
  return <div className="system-health">
    <button type="button" className={'system-health-button tone-' + tone} aria-haspopup="dialog"
      title="Показать состояние системы и причины ограничений" onClick={() => dialog.current?.showModal()}>
      <span className="system-health-dot" aria-hidden="true" />
      <span role="status">{label}</span>
      {!unknown && health.issues.length > 0 && <span className="system-health-count">{health.issues.length}</span>}
    </button>
    <dialog ref={dialog} className="system-health-dialog" aria-labelledby="system-health-title"
      onClick={event => { if (event.target === dialog.current) dialog.current?.close(); }}>
      <div className="system-health-dialog-content">
        <div className="system-health-heading">
          <h2 id="system-health-title">Состояние системы</h2>
          <button type="button" className="btn btn-sm" onClick={() => dialog.current?.close()}>Закрыть</button>
        </div>
        <p className={'system-health-label tone-' + tone}>{label}</p>
        {unknown ? <p className="text-secondary">{error || (stale ? 'Данные давно не обновлялись. Текущее состояние неизвестно.' : 'Ожидаем актуальный ответ сервера.')}</p> : <>
          {health.info.map((message, index) => <p className="text-sm" key={index}>{message}</p>)}
          {health.issues.length > 0 && <ul className="system-health-issues">{health.issues.map((issue, index) =>
            <li key={issue.code + ':' + index} className={'tone-' + issue.severity}>{issue.message}</li>
          )}</ul>}
          {health.lastScanAt && <p className="text-xs text-muted">Последний старт проверки: {formatHistoryTime(health.lastScanAt)}</p>}
        </>}
        {receivedAt !== null && <p className="text-xs text-muted">Ответ сервера получен: {formatHistoryTime(new Date(receivedAt).toISOString())}</p>}
      </div>
    </dialog>
  </div>;
}
